module.exports = __webpack_public_path__ + "./Oscar_ec82d44f4e905002c0dae29be399d57c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Oscar.jpg
// module id = 574
// module chunks = 0